import cloneDeep from 'lodash/cloneDeep';
import { get } from '@/api/mouvementClient/index';
import formatDate from '@/services/general/formatDate';
import getEcheanceId from '@/services/reglement/getEcheanceId';
import { SENS_ACHAT } from '@/configuration/devisConf';
import getTradByTypeFacture from '../facture/getTradByTypeFacture';

export default
async function genererTableauDesLettragesModification(allLettrage, idReglement, dataTable) {
  const montants = [];
  const promises = [];
  const id = [];
  const tabLettrages = [];
  for (let i = 0; i < allLettrage.length; i += 1) {
    promises.push(get(getEcheanceId(idReglement, allLettrage[i])));
    montants.push(allLettrage[i].montant);
    id.push(allLettrage[i].id);
  }
  const mouvements = await Promise.all(promises);
  for (let i = 0; i < allLettrage.length; i += 1) {
    if (mouvements[i].data.result) {
      const mouvement = mouvements[i].data.result;
      const newLettrages = {
        idLettrage: id[i],
        operationDiverseId: mouvement.operationDiverseId,
        remiseBancaireId: mouvement.remiseBancaireId,
        dateEcheance: formatDate(mouvement.dateMouvement),
        idEcheance: mouvement.id,
        montant: mouvement.credit > mouvement.debit
          ? mouvement.credit : mouvement.debit,
        montantRestant: mouvement.resteALettrer + parseFloat(montants[i].toString()),
        inputLetterage: parseFloat(montants[i].toString()),
        solde: mouvement.resteALettrer,
        libelle: mouvement.libelle,
        idFacture: mouvement.factureId,
        facture: mouvement.facture,
        modeReglement: mouvement.modeReglement,
        soldeSave: cloneDeep(mouvement.resteALettrer)
          + parseFloat(montants[i].toString()),
        tousLettrages: mouvement.lettrages,
        typeDePiece: mouvement.typeDePiece,
      };
      if (mouvement.facture !== null) {
        newLettrages.type = getTradByTypeFacture(mouvement.facture.sousType);
        newLettrages.montant = mouvement.facture.sens === SENS_ACHAT
          ? mouvement.credit - mouvement.debit
          : mouvement.debit - mouvement.credit;
      }
      tabLettrages.push(newLettrages);
    }
  }
  tabLettrages.forEach((unitLettrage) => {
    dataTable.forEach((lineData) => {
      if (unitLettrage.idEcheance === lineData.idEcheance) {
        const idx = dataTable.indexOf(lineData);
        dataTable[idx] = unitLettrage;
        unitLettrage.assigned = true;
      }
    });
  });
  tabLettrages.forEach((unitLettrage) => {
    if (unitLettrage.assigned === false || unitLettrage.assigned === undefined) {
      dataTable.push(unitLettrage);
    }
  });
  return dataTable;
}
